import {StoritevEnum} from '../../../../assets/js/Enum/StoritevEnum.js'
import {StoritevVrstaEnum} from '../../Enum/StoritevVrstaEnum'
export const SeznamVrednosti = {
  methods: {
    GetVrsteStoritveInternet () {
      return [
        StoritevVrstaEnum.INTERNET_PRD,
        StoritevVrstaEnum.INTERNET_SRD,
        StoritevVrstaEnum.INTERNET_OPTIKA,
        StoritevVrstaEnum.INTERNET_COAX,
        StoritevVrstaEnum.TRZNI_PAKET
      ]
    },
    GetIzvzeteVezave () {
      return [
        StoritevEnum._12_MESECNO_ODPLACILO_OBROKOV,
        StoritevEnum._24_MESECNO_ODPLACILO_OBROKOV,
        StoritevEnum._3_MESECNO_ODPLACILO_OBROKOV,
        StoritevEnum._6_MESECNO_ODPLACILO_OBROKOV,
        StoritevEnum._36_MESECNO_ODPLACILO_OBROKOV]
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SeznamVrednosti.js